import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "workflowContaineer"
};
const _hoisted_2 = {
  class: "workflowTitle"
};
const _hoisted_3 = {
  class: "workflowSubtitle"
};
const _hoisted_4 = {
  key: 1,
  class: "workflowTitle"
};
const _hoisted_5 = {
  ref: "workflowInstanceBlock",
  class: "workflowInstanceBlock"
};
const _hoisted_6 = {
  ref: "workflowEtat",
  class: "workflowEtat"
};
const _hoisted_7 = {
  class: "graph"
};
const _hoisted_8 = {
  class: "etapeGroupe"
};
const _hoisted_9 = {
  class: "workflowGroup inactive"
};
const _hoisted_10 = {
  key: 0,
  class: "transition active"
};
const _hoisted_11 = {
  class: "etapeGroupe"
};
const _hoisted_12 = {
  class: "boxEtape"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1,
  class: "etape validate"
};
const _hoisted_15 = {
  class: "workflowGroup inactive"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  class: "step-name"
};
const _hoisted_18 = {
  key: 1,
  class: "role-sub"
};
const _hoisted_19 = {
  key: 0,
  class: "transition active"
};
const _hoisted_20 = {
  class: "etapeGroupe"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 1,
  class: "boxEtape rejected"
};
const _hoisted_23 = {
  class: "workflowGroup rejected"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  class: "step-name"
};
const _hoisted_26 = {
  key: 1,
  class: "role-sub"
};
const _hoisted_27 = {
  key: 0,
  class: "transition active"
};
const _hoisted_28 = {
  class: "etapeGroupe"
};
const _hoisted_29 = {
  class: "boxEtape"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  key: 1,
  class: "etape active"
};
const _hoisted_32 = {
  class: "workflowGroup active"
};
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = {
  class: "step-name"
};
const _hoisted_35 = {
  key: 1,
  class: "role-sub"
};
const _hoisted_36 = {
  key: 0,
  class: "transition inactive"
};
const _hoisted_37 = {
  class: "etapeGroupe"
};
const _hoisted_38 = {
  class: "boxEtape"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  key: 1,
  class: "etape inactive"
};
const _hoisted_41 = {
  class: "workflowGroup inactive"
};
const _hoisted_42 = {
  key: 0
};
const _hoisted_43 = {
  class: "step-name"
};
const _hoisted_44 = {
  key: 1,
  class: "role-sub"
};
const _hoisted_45 = {
  class: "etapeGroupe"
};
const _hoisted_46 = {
  class: "workflowGroup inactive"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_workflow_rejected_block = _resolveComponent("workflow-rejected-block");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.workflow.rejected ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.reject.validation.title")), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.reject.validation.subtitle")), 1)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.in.validation.title")), 1)])), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "boxEtape"
  }, [_createElementVNode("div", {
    class: "first"
  })], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.send.for.validation.1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.send.for.validation.2")), 1)])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "transition active"
  }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflow.steps, (step, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: step.order,
      class: "ut-step"
    }, [step.order < _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      alt: "userImage",
      class: "etape validate anonymous",
      src: step.usrImg
    }, null, 8, _hoisted_13)) : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
      class: "tick"
    }, null, -1)]))]))]), _createElementVNode("div", _hoisted_15, [!_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("workflow.validation.group")), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.getStepDisplayName(step)), 1), _ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(step.role), 1)) : _createCommentVNode("", true)])])], 64)) : _ctx.workflow.rejected && step.order === _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      alt: "userImage",
      class: "boxEtape rejected anonymous",
      src: step.usrImg
    }, null, 8, _hoisted_21)) : (_openBlock(), _createElementBlock("div", _hoisted_22)), _createElementVNode("div", _hoisted_23, [!_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t("workflow.validation.group")), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.getStepDisplayName(step)), 1), _ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(step.role), 1)) : _createCommentVNode("", true)])])], 64)) : step.order === _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      alt: "userImage",
      class: "etape active anonymous",
      src: step.usrImg
    }, null, 8, _hoisted_30)) : (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
      class: "rondActif"
    }, null, -1)]))]))]), _createElementVNode("div", _hoisted_32, [!_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.$t("workflow.validation.group")), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.getStepDisplayName(step)), 1), _ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(step.role), 1)) : _createCommentVNode("", true)])])], 64)) : step.order > _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      alt: "userImage",
      class: "etape inactive anonymous",
      src: step.usrImg
    }, null, 8, _hoisted_39)) : (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
      class: "empty"
    }, null, -1)]))]))]), _createElementVNode("div", _hoisted_41, [!_ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.$t("workflow.validation.group")), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.getStepDisplayName(step)), 1), _ctx.workflow.anonymous ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(step.role), 1)) : _createCommentVNode("", true)])])], 64)) : _createCommentVNode("", true)]);
  }), 128)), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "transition inactive"
  }, null, -1)), _createElementVNode("div", _hoisted_45, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "boxEtape"
  }, [_createElementVNode("div", {
    class: "last"
  })], -1)), _createElementVNode("div", _hoisted_46, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.speach.publication.1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.speach.publication.2")), 1)])])])], 512)], 512), _ctx.workflow.rejected ? (_openBlock(), _createBlock(_component_workflow_rejected_block, {
    key: 2,
    comment: _ctx.workflow.rejected.comment,
    date: new Date(_ctx.workflow.rejected.date),
    "group-name": _ctx.getRejectedDisplayName(),
    "step-number": _ctx.workflow.rejected.stepNumber,
    "steps-count": _ctx.workflow.steps.length,
    "anonymous-workflow": _ctx.workflow.anonymous
  }, null, 8, ["comment", "date", "group-name", "step-number", "steps-count", "anonymous-workflow"])) : _createCommentVNode("", true)]);
}